export const GET_USER_BY_EMPLOYEEID = 'GET_USER_BY_EMPLOYEEID';
export const GET_USER_BY_EMPLOYEEID_SUCCESS = 'GET_USER_BY_EMPLOYEEID_SUCCESS';
export const GET_USER_BY_EMPLOYEEID_FAILURE = 'GET_USER_BY_EMPLOYEEID_FAILURE';